import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinimize = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.05 3.75V10.25H20.55M20.55 3.75L14.8 9.5M10.55 20.25V13.75H4.05005M4.05005 20.25L9.80005 14.5",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})]
});
export default SvgMinimize;
